import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import HeaderButton from '../../vuecomponents/layout/HeaderButton.vue';
import Resource from '../../src/resources/Resource.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountMenu',
  setup(__props, { expose }) {
  expose();

let MenuOpen = ref(false);

const __returned__ = { MenuOpen, HeaderButton, Resource }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})